import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import React, { memo } from "react";
import TextField from '@mui/material/TextField';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { FormControlLabel, Select } from "@mui/material";
import { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { useState } from "react";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import PlatFormType from "@warriortrading/warriortrading.hermes.common.feathers/enums/platformType";
import BrowserType from "@warriortrading/warriortrading.hermes.common.feathers/enums/browserType";
import SiteSourceType from "@warriortrading/warriortrading.hermes.common.feathers/enums/siteSourceType";
import TicketStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/ticketStatus";

export const TicketsList = memo(() => {
    const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
        sorters: {
            initial: [
              {
                field: "updatedAt",
                order: "desc"
              }
            ]
          },
        pagination: {
            pageSize: 10
          }
    });

    
    const columns = React.useMemo<GridColumns<any>>(
        () => [
            {
                field: "id",
                headerName: "Id",
                minWidth: 100,
                hideable: false,
            },
            {
                field: "status",
                headerName: "Status",
                minWidth: 100,
                hideable: false,
                renderCell: function render({ row }) {
                    return TicketStatus.fromValue(row.status)?.name;
                },
            },
            {
                field: "title",
                headerName: "Title",
                minWidth: 250,
                flex: 1,
                hideable: false,
            },
            {
                field: "browser",
                headerName: "Browser",
                minWidth: 120,
                hideable: false,
                renderCell: function render({ row }) {
                    return BrowserType.fromValue(row.browser)?.name;
                },
            },
            {
                field: "platform",
                headerName: "Platform",
                minWidth: 120,
                hideable: false,
                renderCell: function render({ row }) {
                    return PlatFormType.fromValue(row.platform)?.name;
                },
            },
            {
                field: "sourceType",
                headerName: "SourceType",
                minWidth: 120,
                hideable: false,
                renderCell: function render({ row }) {
                    return SiteSourceType.fromValue(row.sourceType)?.name;
                },
            },
            {
                field: "reporter.nickname",
                headerName: "UserName",
                minWidth: 120,
                hideable: false,
            },
            {
                field: "updatedAt",
                headerName: "UpdatedAt",
                minWidth: 160,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row.updatedAt) {
                        return new Date(row.updatedAt).toLocaleString();
                    } else {
                        return "";
                    }
                },
            },
            {
                field: "hasAttachments",
                headerName: "HasAttachments",
                minWidth: 140,
                hideable: false,
            },
            {
                field: "actions",
                headerName: "Actions",
                hideable: false,
                sortable: false,
                renderCell: function render({ row }) {
                    return (
                        <>
                            <EditButton hideText recordItemId={row.id} />
                        </>
                    );
                },
                align: "center",
                headerAlign: "center",
                minWidth: 100,
            },
        ],
        [],
    );

    // search parts
    const [status, setStatus] = useState<any>("");
    const [sourceTypeSearch, setSourceTypeSearch] = useState<any>("");
    const [id, setId] = useState("");
    const [userName, setUserName] = useState("");
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const timeReverse = (date: any) => {
        const Y = date.getFullYear() + '-';
        const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
        const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "";
        return Y+M+D;
    }
    const handleFilter = (
    ) => {
        setCurrent(1);
        setPageSize(10);
        let searchArr: {field: string; value: string; operator: string}[] = [];
        if (status || status === 0) {
            searchArr.push({
                field: "status",
                value: `${status}`,
                operator: "eq",
            });
        } 
        if (sourceTypeSearch || sourceTypeSearch === 0) {
            searchArr.push({
                field: "sourceType",
                value: `${sourceTypeSearch}`,
                operator: "eq",
            });
        } 
        if (id) {
            searchArr.push({
                field: "id",
                value: `${id}`,
                operator: "eq",
            });
        } 
        if (userName) {
            searchArr.push({
                field: "nickname",
                value: `${userName}`,
                operator: "eq",
            });
        }   
        if (startDate) {
            searchArr.push({
                field: "startAt",
                value: `${timeReverse(startDate?.["$d" as any])}`,
                operator: "eq",
            });
        } 
        if (endDate) {
            searchArr.push({
                field: "endAt",
                value: `${timeReverse(endDate?.["$d" as any])}`,
                operator: "eq",
            });
        }
        setFilters(searchArr as any);
    };

    const clearFun = () => {
        setStatus("");
        setSourceTypeSearch("");
        setId("");
        setUserName("");
        setStartDate(null);
        setEndDate(null);
    }

    return (
        <List>
            <FormControlLabel
                label=""
                style={{width: "100%"}}
                control={
                    <>
                    <div style={{width: "100%"}}>
                        <div style={{display:"flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginLeft: "19px", paddingRight: "15px", marginBottom: "12px"}}>
                            <TextField id="standard-basic" label="Id" variant="standard" value={id} onChange={(e) => setId(e.target.value)} style={{width: "30%"}}/>
                            <TextField id="standard-basic" label="UserName" variant="standard" value={userName} onChange={(e) => setUserName(e.target.value)} style={{width: "30%"}}/>
                            <FormControl style={{width: "30%"}}>
                                <InputLabel id="status">Status : </InputLabel>
                                <Select
                                    labelId="status"
                                    value={status as any}
                                    label="Status"
                                    variant="standard"
                                    onChange={(event: SelectChangeEvent) => {
                                        setStatus(event.target.value as any);
                                    }}
                                >
                                    {
                                        Object.values(TicketStatus)[0].map((item: any) => {
                                            return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <div style={{width: "5%"}}>
                                <ClearOutlinedIcon onClick={clearFun}/>
                            </div>
                        </div>
                        <div style={{display:"flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginLeft: "19px", paddingRight: "15px", marginBottom: "12px"}}>
                            <FormControl style={{width: "30%"}}>
                                <InputLabel id="sourceTypeSearch">SourceType : </InputLabel>
                                <Select
                                    labelId="sourceTypeSearch"
                                    value={sourceTypeSearch as any}
                                    label="SourceType"
                                    variant="standard"
                                    onChange={(event: SelectChangeEvent) => {
                                        setSourceTypeSearch(event.target.value as any);
                                    }}
                                >
                                    {
                                        Object.values(SiteSourceType)[0].map((item: any) => {
                                            return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <DatePicker label="StartDate" value={startDate} slotProps = {{ textField: { style: {width: "30%"} } }} onChange={(newValue) => {
                                    setStartDate(newValue);
                                }}
                            />
                            <DatePicker label="EndDate" value={endDate} slotProps = {{ textField: { style: {width: "30%"} } }} onChange={(newValue) => {
                                    setEndDate(newValue);
                                }}
                            />
                            <div style={{width: "5%"}}>
                                <SearchIcon onClick={handleFilter}/>
                            </div>
                        </div>
                    </div>
                    </>
                }
            />
             <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
        </List>
    );
});
